import { render, staticRenderFns } from "./item.vue?vue&type=template&id=40370bb2&scoped=true&lang=html&"
import script from "./item.vue?vue&type=script&lang=js&"
export * from "./item.vue?vue&type=script&lang=js&"
import style0 from "./item.vue?vue&type=style&index=0&id=40370bb2&lang=scss&scoped=true&"
import style1 from "./item.vue?vue&type=style&index=1&lang=scss&module=skuItem&"




function injectStyles (context) {
  
  this["skuItem"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "40370bb2",
  null
  
)

export default component.exports